import { render, staticRenderFns } from "./SanitaryCompaniesList.vue?vue&type=template&id=40dc0b7c&"
import script from "./SanitaryCompaniesList.vue?vue&type=script&lang=js&"
export * from "./SanitaryCompaniesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40dc0b7c')) {
      api.createRecord('40dc0b7c', component.options)
    } else {
      api.reload('40dc0b7c', component.options)
    }
    module.hot.accept("./SanitaryCompaniesList.vue?vue&type=template&id=40dc0b7c&", function () {
      api.rerender('40dc0b7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/61221000-4/components/SanitaryCompaniesList.vue"
export default component.exports